import { SUBSCRIPTION_DETAILS_ENDPOINT } from "@config/endpoints";

import { ThunkActionDispatch } from "@typings/reduxThunkActions";

import { AsyncActionResult } from "@services/AsyncActionCreatorFactory";
import { ReduxActionNameCreator } from "@services/ReduxActionNameCreator";

import { asyncActionCreator } from "@app/services/AsyncActionCreator";

const action = new ReduxActionNameCreator("subscription");

export const FETCH_SUBSCRIPTION_BY_ID = action.make("fetch subscription by id");

export const fetchSubscriptionById =
  (uuid: string) =>
  async (dispatch: ThunkActionDispatch): Promise<AsyncActionResult> => {
    const action = await asyncActionCreator({
      url: SUBSCRIPTION_DETAILS_ENDPOINT.replace("{subscriptionUuid}", uuid),
      action: FETCH_SUBSCRIPTION_BY_ID,
    });

    return dispatch(action);
  };
